module.exports = __webpack_public_path__ + "static/img/combine_back.371e049.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/combine_back.jpg?20181011
// module id = MCbv
// module chunks = 1